/**
 * Main menu for wheel that highlights top level wheel aspects.
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import SymbolCommunity from './symbols/SymbolCommunityBig';
import SymbolEnvironment from './symbols/SymbolEnvironmentBig';
import SymbolHealth from './symbols/SymbolHealthBig';
import SymbolRelationship from './symbols/SymbolRelationshipBig';
import SymbolSecurity from './symbols/SymbolSecurityBig';
import SymbolPurpose from './symbols/SymbolPurposeBig';
import WheelCenter from './WheelCenter';

function WheelMainMenu({
  hoveredAspect,
  listItems,
  pieSlices,
}) {
  return (
    <div>
      <div className="wheel-wrapper">
        <svg
          id="menu"
          viewBox="-2 -2 504 504"
        >
          <title>Interactive wellbeing model</title>
          <desc>Explore factors of wellbeing</desc>
          <g className="symbols-container">
            <SymbolEnvironment hoveredAspect={hoveredAspect} />
            <SymbolHealth hoveredAspect={hoveredAspect} />
            <SymbolRelationship hoveredAspect={hoveredAspect} />
            <SymbolSecurity hoveredAspect={hoveredAspect} />
            <SymbolPurpose hoveredAspect={hoveredAspect} />
            <SymbolCommunity hoveredAspect={hoveredAspect} />
          </g>
          <g className="pie-slices">
            {pieSlices()}
          </g>
        </svg>
      </div>
      <WheelCenter />
      <div className="wheel-labels">
        <ul>
          {listItems[0]}
          {listItems[1]}
          {listItems[5]}
          {listItems[2]}
          {listItems[4]}
          {listItems[3]}
        </ul>
      </div>
    </div>
  );
}

WheelMainMenu.propTypes = {
  hoveredAspect: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.shape({})),
  pieSlices: PropTypes.func,
};

export default WheelMainMenu;



// WEBPACK FOOTER //
// js/src/wheel/WheelMainMenu.js